import React, { useEffect, useMemo, useState, Fragment, useRef } from 'react';
import { TextField, IconButton, Grid, Typography, withStyles, Button, Box, makeStyles } from '@material-ui/core';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { TreatmentFormStyles } from './styles';
import UnitButton from './UnitButton';
import CustomAutoComplete from '../../forms/AutoComplete/index';
import {
    FILLER_AREAS,
    TREATMENT_TYPES,
    DILUTION_UNITS,
    TREATMENT_NOTE_TYPES,
    BOTOX_TREATMENT_AREAS,
    DEFAULT_UNIT_VALUES
} from '../../../../collums-constants';
import InputMask from 'react-input-mask';
import ColorPicker from './ColorPicker';
import { v4 } from 'uuid';
import { PropTypes } from 'prop-types';
import Canvas from '../../../canvas/Canvas';
import { toastr } from 'react-redux-toastr';
import ProductPicker from './ProductPicker';
import { groupBy, sumBy } from 'lodash';
import { AddPhoto } from './../../../../assets/icons';
import SaveTemplate from '../SaveTemplate';
import Table from './laserTreatment/Table';
import BasicLaserIPLTable from './basicLaserIPLTreatment/Table';
import isInvalidExpiryDate from './../../../../services/helpers/isInvalidExpiryDate';
import { useSelector } from 'react-redux';
import roundUnitValue from '../../../../services/helpers/roundUnitValue';
import resetTreatmentType from './../../../../services/helpers/resetTreatmentType';
import _ from 'lodash';
import addCanvasCircle from './../../../../services/helpers/addCanvasCircle';
import DeleteTemplatesModal from '../../../../collums-components/components/common/DeleteTemplatesModal';
import TreatmentNoteApi from '../../../../collums-components/api/TreatmentNoteApi';
import truncUnitCounter from '../../../../services/helpers/truncUnitCounter';
import DEFAULT_TREATMENT_PHOTOS_BY_GENDER from '../../../../collums-constants/treatmentImages';
import PopoverOptions from '../TreatmentNoteForm/PopoverOptions';
import axios from 'axios';
import extendCanvasGroupProps from '../../../../services/helpers/extendCanvasGroupProps';
import { modalsButtonStyles } from '../../../../collums-constants/styles/stylesheets/buttonsStyles';
import addCanvasSquare from '../../../../services/helpers/addCanvasSquare';
import TreatmentImagesApi from '../../../../collums-components/api/TreatmentImagesApi';

const fillerUnits = Array(5)
    .fill(0)
    .map((_, index) => parseFloat(((index + 1) * 0.1).toFixed(1)));
const quantities = Array(15)
    .fill(0)
    .map((_, index) => String(index + 1));

const TreatmentDesignForm = ({
    classes,
    formRef,
    fillerProducts,
    loadTemplates,
    templates,
    canvas,
    uploadedPhotos,
    toxinProducts,
    getDailyData,
    hasChangedNoteType,
    canvasSizeProps,
    setIsCurrentlyEditingNote,
    setShowUploadPhotosModal,
    setShowTreatmentPhotosModal,
    customer,
    setUploadedDocs,
    setIsFromDesignTab,
    ToUploadLhrTableRef,
    ToUploadBliplTableRef,
    setComparisionLHRData,
    setComparisionBLIPLData,
    setHasChangedNoteType,
    latestToxins,
    latestFillers
}) => {
    const dragSnapShot = useRef([]);
    const organisation = useSelector(state => state.calendar.organisation);
    const [usedProduct, setUsedProduct] = useState({});
    const [form, setForm] = useState(formRef.current || { treatmentColor: '#ffffff' });
    const [fillerOptions, setFillerOptions] = useState({});
    const [isTemplateModalVisible, setIsTemplateModalVisible] = useState(false);
    const [requiredFieldsCompleted, setRequiredFieldsCompleted] = useState(false);
    const [isOpenDeleteTemplateModal, setIsOpenDeleteTemplateModal] = useState(false);
    const [customUnits, setCustomUnits] = useState(DEFAULT_UNIT_VALUES);
    const [showOptionsMenu, setShowOptionsMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [templatesToxin, setTemplatesToxin] = useState(templates.toxin || []);
    const [templatesFiller, setTemplatesFiller] = useState(templates.filler || []);
    const [backendTreatmentImages, setBackendTreatmentImages] = useState([]);
    const globalStyles = makeStyles(modalsButtonStyles)();

    useEffect(() => {
        formRef.current = form;
        setFillerOptions({ ...fillerOptions });
        const getUsedProduct = (() => {
            if (form.treatmentType === TREATMENT_TYPES.TOXIN) {
                return { toxin: form.toxin?.id, color: form.treatmentColor };
            }
            return { currentFiller: form.currentFiller, color: getCurrentFillerColor() };
        })();
        setUsedProduct({
            area: form.area,
            unit: form.unit,
            ...getUsedProduct
        });

        if (form.treatmentType === TREATMENT_TYPES.TOXIN) {
            if (form.toxin && form.toxin.id) {
                const toxinId = form.toxin.id;
                const selectedToxin = organisation?.injectionDoses?.find(
                    injectionDose => injectionDose.toxin === toxinId
                );
                setCustomUnits(selectedToxin?.doseUnits || DEFAULT_UNIT_VALUES);
            } else {
                setCustomUnits(DEFAULT_UNIT_VALUES);
            }
            if (!form.toxin || !form.dilution || !form.lotNo || !form.expiry || !form.area) {
                setRequiredFieldsCompleted(false);
                return;
            }
            if (!form.expiry || isInvalidExpiryDate(form.expiry)) {
                setRequiredFieldsCompleted(false);
                return;
            }
        } else {
            const selectedFiller = (form.fillers || []).find(
                el => el.filler.id === form.currentFiller && el.quantity === form.currentFillerQuantity
            );
            if (!selectedFiller) {
                setRequiredFieldsCompleted(false);
                return;
            }
        }
        setRequiredFieldsCompleted(true);
    }, [form]); //eslint-disable-line

    useEffect(() => {
        const loadTreatmentImages = async () => {
            try {
                const images = await TreatmentImagesApi.list();
                setBackendTreatmentImages(images || []);
            } catch (error) {
                console.error('Error loading treatment images:', error);
            }
        };
        loadTreatmentImages();
    }, []);

    useEffect(() => {
        if (form.treatmentType === 'Filler' && !form.area) {
            form.area = 'Any';
        }
    }, [form.treatmentType]); //eslint-disable-line

    useEffect(() => {
        setForm({ ...(formRef.current || {}) });
    }, [hasChangedNoteType, formRef]);

    const resetFillerOptionData = () => {
        setFillerOptions({});
    };

    useEffect(() => {
        resetFillerOptionData();
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        updateTemplates(latestToxins).then(result => {
            const updatedTemplatesToxin = [...templatesToxin];
            if (result[1]) {
                updatedTemplatesToxin.unshift({
                    name: 'Last treatment but one',
                    canvasData: result[1]
                });
            }
            if (result[0]) {
                updatedTemplatesToxin.unshift({
                    name: 'Last treatment',
                    canvasData: result[0]
                });
            }
            setTemplatesToxin(updatedTemplatesToxin);
        });
        updateTemplates(latestFillers).then(result => {
            const updatedTemplatesFiller = [...templatesFiller];
            if (result[1]) {
                const fillerData = JSON.parse(result[1]);
                updatedTemplatesFiller.unshift({
                    name: 'Last treatment but one',
                    canvasData: result[1],
                    circles: fillerData.objects
                        .filter(el => el.shape === 'circle')
                        .map(el => ({ product: el.product })),
                    squares: fillerData.objects.filter(el => el.shape === 'square').map(el => ({ product: el.product }))
                });
            }
            if (result[0]) {
                const fillerData = JSON.parse(result[0]);
                updatedTemplatesFiller.unshift({
                    name: 'Last treatment',
                    canvasData: result[0],
                    circles: fillerData.objects
                        .filter(el => el.shape === 'circle')
                        .map(el => ({ product: el.product })),
                    squares: fillerData.objects.filter(el => el.shape === 'square').map(el => ({ product: el.product }))
                });
            }
            setTemplatesFiller(updatedTemplatesFiller);
        });
        //eslint-disable-next-line
    }, []);

    const updateForm = () => {
        if (formRef.current.canvasDataPerPage && Object.keys(formRef.current.canvasDataPerPage).length > 0) {
            // Multi-page: collect products from all pages
            const allProducts = [];
            Object.keys(formRef.current.canvasDataPerPage).forEach(pageIndex => {
                const pageData = formRef.current.canvasDataPerPage[pageIndex];
                if (pageData) {
                    try {
                        const jsonCanvas = JSON.parse(pageData);
                        const pageProducts = (jsonCanvas.objects || [])
                            .filter(el => el.type === 'group')
                            .map(el => ({
                                product: el.product,
                                area: el.area,
                                unit: el.unit
                            }))
                            .filter(el => el.product && el.unit && el.area);
                        allProducts.push(...pageProducts);
                    } catch (e) {
                        console.error(`Error parsing canvas data for page ${pageIndex}:`, e);
                    }
                }
            });
            formRef.current.usedProducts = allProducts;
        } else {
            formRef.current.usedProducts = canvas.current
                .getObjects()
                .filter(el => el.type === 'group')
                .map(el => ({
                    product: el.product,
                    area: el.area,
                    unit: el.unit
                }))
                .filter(el => el.product && el.unit && el.area);
        }

        const canvasText = JSON.stringify(canvas.current.toJSON());
        const canvasData = form.canvasData;
        const hasChanged = canvasData !== canvasText;

        if (hasChanged) {
            setIsCurrentlyEditingNote(true);
        }

        formRef.current.canvasData = canvasText;
        setForm({ ...formRef.current });
    };

    const getCanvasData = async url => {
        const canvasData = await axios.get(url);
        return canvasData.data;
    };

    const updateTemplates = async treatments => {
        const newTemplates = [];
        for (let i = 0; i < treatments.length; i++) {
            if (newTemplates.length === 2) {
                break;
            }
            const canvasData = await getCanvasData(treatments[i].canvasDataUrl);
            if (canvasData.objects && canvasData.objects.length > 0) {
                newTemplates.push(JSON.stringify(canvasData));
            }
        }
        return newTemplates;
    };

    const filterCanvasObjects = canvasEl => {
        return canvasEl.area && (canvasEl.toxin || canvasEl.currentFiller) && canvasEl.unit && canvasEl.color;
    };

    const getCircleUnits = () => {
        return canvas?.current?._objects
            ?.filter(filterCanvasObjects)
            .filter(el => !el.shape || el.shape === 'circle')
            .map(canvasEl => ({
                area: canvasEl.area,
                color: canvasEl.color,
                borderColor: canvasEl.borderColor,
                unit: canvasEl.unit,
                product: canvasEl.product,
                top: canvasEl.top,
                left: canvasEl.left
            }));
    };

    const getSquareUnits = () => {
        return canvas?.current?._objects
            ?.filter(filterCanvasObjects)
            .filter(el => !el.shape || el.shape === 'square')
            .map(canvasEl => ({
                area: canvasEl.area,
                color: canvasEl.color,
                borderColor: canvasEl.borderColor,
                unit: canvasEl.unit,
                product: canvasEl.product,
                top: canvasEl.top,
                left: canvasEl.left
            }));
    };

    const hasDroppedUnits = () => {
        return canvas?.current?._objects?.some(filterCanvasObjects);
    };

    const addFiller = () => {
        const fillerProps = ['filler', 'quantity', 'color', 'lotNo', 'expiry'];
        const fillerCheck = filler => {
            if (filler === 'color' && !fillerOptions?.['color']) {
                fillerOptions.color = '#FFFFFF';
            }
            if (!fillerOptions?.[filler]) {
                return filler;
            }
        };
        const allFieldsMissing = fillerProps.filter(fillerCheck);
        if (allFieldsMissing.length) {
            return toastr.error(`Missing ${allFieldsMissing[0]} field information`);
        }

        if (isInvalidExpiryDate(fillerOptions.expiry)) {
            return toastr.error('invalid expiry date');
        }
        const fillers = [...(form.fillers || []), { ...fillerOptions, id: v4() }];
        resetFillerOptionData();
        setForm({ ...formRef.current, fillers });
    };

    const removeFiller = id => {
        const fillers = form.fillers.filter(el => el.filler.id !== id);
        canvas.current._objects = canvas.current._objects.filter(el => el.currentFiller !== id);
        formRef.current.usedProducts = (formRef.current.usedProducts || []).filter(el => el.product !== id);
        setForm({
            ...formRef.current,
            fillers,
            currentFiller: id === form.currentFiller ? undefined : form.currentFiller
        });
    };

    const getCurrentFillerColor = () => {
        const selectedFiller = (form.fillers || []).find(
            el => el.filler.id === form.currentFiller && el.quantity === form.currentFillerQuantity
        );

        return selectedFiller?.color;
    };

    // const { areas, totalUnits, totalUnused } = useMemo(() => {
    const { areas, totalUnits } = useMemo(() => {
        if (form.treatmentType === TREATMENT_TYPES.TOXIN) {
            const toxins = (form.usedProducts || []).map(el => ({ ...el, unit: truncUnitCounter(el.unit, true) }));
            const toxinsGroupedByArea = groupBy(toxins, 'area');
            const totalUnits = truncUnitCounter(sumBy(toxins, 'unit'));
            const areas = Object.keys(toxinsGroupedByArea).map(name => {
                const usedUnits = truncUnitCounter(sumBy(toxinsGroupedByArea[name], 'unit'));
                return {
                    usedUnits,
                    name
                };
            });
            return {
                areas,
                totalUnits
            };
        }
        if (form.treatmentType === TREATMENT_TYPES.FILLER) {
            const fillers = (form.usedProducts || []).map(el => ({ ...el, unit: Number(el.unit) }));
            const fillersGroupedByArea = groupBy(fillers, 'area');
            const totalUnits = roundUnitValue(sumBy(fillers, 'unit'));
            const areas = Object.keys(fillersGroupedByArea).map(name => {
                const usedUnits = roundUnitValue(sumBy(fillersGroupedByArea[name], 'unit'));
                return {
                    usedUnits,
                    name
                };
            });
            // const totalVol = sum((form.fillers || []).map(el => (el.filler.vol || 0) * Number(el.quantity)));
            return {
                areas,
                totalUnits
                // totalUnused: totalVol ? roundUnitValue(totalVol - totalUnits) : 0
            };
        }
        return {
            areas: [],
            totalUnits: 0
        };
    }, [form.usedProducts, form.fillers]); //eslint-disable-line

    const Areas = () => {
        return (
            <>
                {areas.map(area => {
                    return (
                        <Fragment key={area.name}>
                            <Grid item xs={11}>
                                <Typography className={`${classes.rightAligned} ${classes.font14}`}>
                                    {area.name}
                                </Typography>
                            </Grid>
                            <Grid item xs={1} className={classes.rightAligned}>
                                <Typography className={classes.font14}>
                                    {form.treatmentType === TREATMENT_TYPES.TOXIN
                                        ? truncUnitCounter(area.usedUnits)
                                        : area.usedUnits}
                                </Typography>
                            </Grid>
                        </Fragment>
                    );
                })}
            </>
        );
    };

    const hasDragErrors = isCustom => {
        const errors = [];
        if (!form.area) {
            errors.push('Need to select an area');
        }
        if (isCustom && (!Number(form.unit) || !form.unit || form.unit < 0)) {
            errors.push('Invalid unit');
        }
        if (form.treatmentType === TREATMENT_TYPES.TOXIN) {
            if (!form.toxin || !form.dilution || !form.lotNo || !form.expiry) {
                errors.push('Fill all toxin information');
            }
            if (!form.expiry || isInvalidExpiryDate(form.expiry)) {
                errors.push('Invalid expiry date');
            }
        } else {
            const selectedFiller = (form.fillers || []).find(
                el => el.filler.id === form.currentFiller && el.quantity === form.currentFillerQuantity
            );
            if (!selectedFiller) {
                errors.push('Filler is not selected');
            }
        }
        return errors;
    };

    const customUnitsDragErrors = hasDragErrors(true);
    const defaultUnitsDragErrors = hasDragErrors();
    const photos = useMemo(
        () => [
            {
                name: 'None',
                url: 'None',
                otherPagesUrl: []
            },
            ..._.uniqBy(
                [
                    ...DEFAULT_TREATMENT_PHOTOS_BY_GENDER.ALL,
                    ...backendTreatmentImages,
                    ...(form.photos || []),
                    ...((uploadedPhotos || [])
                        .filter(el => !el?.cantUpload && !el?.isUploading)
                        .map(photo => ({
                            name: photo.name,
                            uploadedAt: new Date(),
                            url: photo.newUrl || photo.url,
                            otherPagesUrl: photo.otherPagesUrl || []
                        })) || [])
                ],
                'url'
            ).sort((a, b) => a.name.localeCompare(b.name))
        ],
        [form.photos, uploadedPhotos, backendTreatmentImages]
    );

    const isFiller = form.treatmentType === TREATMENT_TYPES.FILLER;
    const isAppearingPhoto =
        Boolean(photos.length !== DEFAULT_TREATMENT_PHOTOS_BY_GENDER.ALL.length) &&
        form.treatmentType !== TREATMENT_TYPES.LHR;

    const onUploadModalCallback = newPhoto => {
        if (newPhoto) {
            setForm({ ...formRef.current, photo: newPhoto });
        }
    };

    const fillerFormLockValidation = () => {
        if (formRef.current.treatmentType === TREATMENT_TYPES.FILLER) {
            return !formRef.current.fillers?.length;
        }

        return false;
    };

    const isValidMonthYear = text => {
        const match = /^(\d{2})\/(\d{2})$/.exec(text);
        if (!match) return false;

        const month = Number(match[1]);

        return month >= 1 && month <= 12;
    };

    const isAddItemInActive =
        formRef.current.lockEdit ||
        !fillerOptions.filler ||
        !fillerOptions.quantity ||
        !fillerOptions.lotNo ||
        !isValidMonthYear(fillerOptions.expiry);

    const fillerTemplatesOptions = () => {
        return templatesFiller.filter(tmpl => {
            const currentFillersIds = (form.fillers || []).map(filler => filler.filler.id);
            const missingInCircle = (tmpl.circles || []).some(el => !currentFillersIds.includes(el.product));
            const missingInSquares = (tmpl.squares || []).some(el => !currentFillersIds.includes(el.product));
            return !missingInCircle && !missingInSquares && (tmpl.circles.length || tmpl.squares.length);
        });
    };

    return (
        <>
            {isTemplateModalVisible && (
                <SaveTemplate
                    closeModal={() => setIsTemplateModalVisible(false)}
                    content={{
                        circles: getCircleUnits(),
                        squares: getSquareUnits()
                    }}
                    loadTemplates={loadTemplates}
                    setTemplatesToxin={setTemplatesToxin}
                    type={formRef.current.treatmentType === TREATMENT_TYPES.FILLER ? 'filler' : 'toxin'}
                />
            )}

            <Grid
                container
                justifyContent="space-around"
                className={classes.container}
                {...(form.treatmentType === TREATMENT_TYPES.LHR && { style: { justifyContent: 'flex-start' } })}
            >
                <Grid container direction="column" alignItems="center" item xs={7}>
                    <Grid
                        container
                        item
                        alignItems="center"
                        className={`${classes.justifyContent} ${classes.marginBottom}`}
                    >
                        <Grid item xs={6}>
                            <CustomAutoComplete
                                id="treatment-form-type"
                                options={Object.values(TREATMENT_TYPES)}
                                disabled={formRef.current?.lockEdit}
                                value={form.treatmentType}
                                onChange={(e, value) => {
                                    resetFillerOptionData();
                                    const newForm = resetTreatmentType(value, formRef.current, canvas, getDailyData);
                                    setIsCurrentlyEditingNote(false);
                                    formRef.current = { ...newForm };
                                    setForm(newForm);
                                    setHasChangedNoteType(formRef.current.treatmentType);
                                }}
                                getOptionLabel={option => option}
                                getOptionValue={option => option}
                                label="Treatment template"
                                required
                                isSelect
                            />
                        </Grid>

                        <Grid item xs={4}>
                            {form.treatmentType !== TREATMENT_TYPES.LHR && (
                                <CustomAutoComplete
                                    id="treatment-image"
                                    options={photos}
                                    value={form.photo || photos[0]}
                                    disabled={
                                        formRef.current.type === TREATMENT_NOTE_TYPES.MEDICAL ||
                                        formRef.current.lockEdit
                                    }
                                    onChange={(e, value) => {
                                        setForm({
                                            ...formRef.current,
                                            photo: value && value?.url === 'None' ? undefined : value,
                                            usedProducts: [],
                                            canvasData: '',
                                            canvasImage: '',
                                            canvasDataPerPage: {},
                                            canvasImagePerPage: {},
                                            canvasDataUrl: undefined,
                                            canvasImageUrl: undefined,
                                            canvasDataUrlPerPage: undefined,
                                            canvasImageUrlPerPage: undefined,
                                            canvasDataUrlOtherPages: undefined,
                                            canvasImageOtherPages: undefined
                                        });
                                    }}
                                    getOptionLabel={option => option?.name}
                                    getOptionValue={option => option?.url}
                                    getValue={url => photos.find(photo => photo.url === url)}
                                    label="Image"
                                    isSelect
                                />
                            )}
                        </Grid>

                        <Grid item xs={1}>
                            <PopoverOptions
                                showOptionsMenu={showOptionsMenu}
                                setShowOptionsMenu={setShowOptionsMenu}
                                anchorEl={anchorEl}
                                setAnchorEl={setAnchorEl}
                                setShowUploadPhotosModal={setShowUploadPhotosModal}
                                setShowTreatmentPhotosModal={setShowTreatmentPhotosModal}
                                customer={customer}
                                setUploadedDocs={setUploadedDocs}
                                formRef={formRef}
                                form={form}
                                onUploadModalCallback={onUploadModalCallback}
                                photos={photos}
                                setForm={setForm}
                                classes={classes}
                                setIsFromDesignTab={setIsFromDesignTab}
                            />
                            {isAppearingPhoto && (
                                <IconButton
                                    className={`${classes.icon} ${classes.camera}`}
                                    onClick={e => {
                                        setAnchorEl(e.currentTarget);
                                        setShowOptionsMenu(true);
                                    }}
                                    disabled={formRef.current.lockEdit}
                                >
                                    <AddPhoto variant="special" opacity={formRef.current.lockEdit ? 0.26 : 1} />
                                </IconButton>
                            )}
                        </Grid>
                    </Grid>

                    {![TREATMENT_TYPES.LHR, TREATMENT_TYPES.BLIPL].includes(form.treatmentType) && Boolean(form.photo) && (
                        <Grid item>
                            <Canvas
                                formRef={formRef}
                                setForm={setForm}
                                canvas={canvas}
                                photo={form.photo}
                                canvasSizeProps={canvasSizeProps}
                                updateForm={updateForm}
                                dragSnapShot={dragSnapShot}
                                shape={formRef.current.currentShape}
                                borderColour={formRef.current.borderColour}
                                treatmentType={form.treatmentType}
                            />
                        </Grid>
                    )}
                </Grid>
                {form.treatmentType === TREATMENT_TYPES.LHR && (
                    <Grid container alignItems="center" item style={{ width: '100%' }}>
                        <Grid item xs={12}>
                            <Table
                                formRef={formRef}
                                form={form}
                                setForm={setForm}
                                ToUploadLhrTableRef={ToUploadLhrTableRef}
                                setComparisionLHRData={setComparisionLHRData}
                                setIsCurrentlyEditingNote={setIsCurrentlyEditingNote}
                            />
                        </Grid>

                        <Grid item xs={7} className={classes.lhrImageArea} alignItems="center">
                            <Grid item xs={4}>
                                <CustomAutoComplete
                                    id="treatment-image"
                                    options={photos}
                                    value={form.photo || photos[0]}
                                    disabled={
                                        formRef.current.type === TREATMENT_NOTE_TYPES.MEDICAL ||
                                        formRef.current.lockEdit
                                    }
                                    onChange={(e, value) => {
                                        setForm({
                                            ...formRef.current,
                                            photo: value && value?.url === 'None' ? undefined : value,
                                            usedProducts: [],
                                            canvasData: '',
                                            canvasImage: '',
                                            canvasDataPerPage: {},
                                            canvasImagePerPage: {},
                                            canvasDataUrl: undefined,
                                            canvasImageUrl: undefined,
                                            canvasDataUrlPerPage: undefined,
                                            canvasImageUrlPerPage: undefined,
                                            canvasDataUrlOtherPages: undefined,
                                            canvasImageOtherPages: undefined
                                        });
                                    }}
                                    getOptionLabel={option => option.name}
                                    getOptionValue={option => option?.url}
                                    getValue={url => {
                                        const photoFound = photos.find(photo => photo.url === url);
                                        return photoFound;
                                    }}
                                    label="Image"
                                    isSelect
                                />
                            </Grid>

                            <Grid item xs={1} className={classes.lhrPhoto}>
                                <IconButton
                                    className={`${classes.icon} ${classes.camera}`}
                                    onClick={e => {
                                        setAnchorEl(e.currentTarget);
                                        setShowOptionsMenu(true);
                                    }}
                                >
                                    <AddPhoto variant="special" />
                                </IconButton>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} />

                        <Grid
                            item
                            {...(form.treatmentType === TREATMENT_TYPES.LHR && {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: 'inherit'
                                }
                            })}
                        >
                            {Boolean(form.photo) && (
                                <Canvas
                                    formRef={formRef}
                                    setForm={setForm}
                                    canvas={canvas}
                                    photo={form.photo}
                                    canvasSizeProps={canvasSizeProps}
                                    updateForm={updateForm}
                                    dragSnapShot={dragSnapShot}
                                    treatmentType={form.treatmentType}
                                />
                            )}
                        </Grid>
                    </Grid>
                )}
                {form.treatmentType === TREATMENT_TYPES.BLIPL && (
                    <Grid container alignItems="center" item style={{ width: '100%' }}>
                        <Grid item xs={12}>
                            <BasicLaserIPLTable
                                formRef={formRef}
                                form={form}
                                setForm={setForm}
                                ToUploadBliplTableRef={ToUploadBliplTableRef}
                                setComparisionBLIPLData={setComparisionBLIPLData}
                                setIsCurrentlyEditingNote={setIsCurrentlyEditingNote}
                            />
                        </Grid>
                        <Grid item xs={7} className={classes.lhrImageArea} alignItems="center">
                            <Grid item xs={4}>
                                <CustomAutoComplete
                                    id="treatment-image"
                                    options={photos}
                                    value={form.photo || photos[0]}
                                    disabled={
                                        formRef.current.type === TREATMENT_NOTE_TYPES.MEDICAL ||
                                        formRef.current.lockEdit
                                    }
                                    onChange={(e, value) => {
                                        setForm({
                                            ...formRef.current,
                                            photo: value && value?.url === 'None' ? undefined : value,
                                            usedProducts: [],
                                            canvasData: '',
                                            canvasImage: '',
                                            canvasDataPerPage: {},
                                            canvasImagePerPage: {},
                                            canvasDataUrl: undefined,
                                            canvasImageUrl: undefined,
                                            canvasDataUrlPerPage: undefined,
                                            canvasImageUrlPerPage: undefined,
                                            canvasDataUrlOtherPages: undefined,
                                            canvasImageOtherPages: undefined
                                        });
                                    }}
                                    getOptionLabel={option => option.name}
                                    getOptionValue={option => option?.url}
                                    getValue={url => {
                                        const photoFound = photos.find(photo => photo.url === url);
                                        return photoFound;
                                    }}
                                    label="Image"
                                    isSelect
                                />
                            </Grid>

                            <Grid item xs={1} className={classes.lhrPhoto}>
                                <IconButton
                                    className={`${classes.icon} ${classes.camera}`}
                                    onClick={e => {
                                        setAnchorEl(e.currentTarget);
                                        setShowOptionsMenu(true);
                                    }}
                                >
                                    <AddPhoto variant="special" />
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} />
                        <Grid
                            item
                            {...(form.treatmentType === TREATMENT_TYPES.BLIPL && {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: 'inherit'
                                }
                            })}
                        >
                            {Boolean(form.photo) && (
                                <Canvas
                                    formRef={formRef}
                                    setForm={setForm}
                                    canvas={canvas}
                                    photo={form.photo}
                                    canvasSizeProps={canvasSizeProps}
                                    updateForm={updateForm}
                                    dragSnapShot={dragSnapShot}
                                    treatmentType={form.treatmentType}
                                />
                            )}
                        </Grid>
                    </Grid>
                )}
                {form.treatmentType && form.treatmentType !== TREATMENT_TYPES.GENERAL && (
                    <Grid container justifyContent="space-between" item xs={5}>
                        <Box style={{ flex: 1 }}>
                            {isFiller && (
                                <>
                                    <Grid container spacing={1} style={{ marginBottom: 10 }}>
                                        <Grid item xs={5}>
                                            <CustomAutoComplete
                                                id="filler-selector"
                                                isSelect
                                                options={fillerProducts
                                                    // .filter(
                                                    //     el =>
                                                    //         !form?.fillers?.some(
                                                    //             fillerItem => fillerItem.filler?.id === el.id
                                                    //         )
                                                    // )
                                                    .sort((a, b) => a.name.localeCompare(b.name))}
                                                value={fillerOptions.filler || null}
                                                onChange={(e, value) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    const dailyFiller = (form.dailyFillers || []).find(
                                                        el => el.toxin === value.id
                                                    );
                                                    if (dailyFiller) {
                                                        setFillerOptions({
                                                            ...fillerOptions,
                                                            filler: value,
                                                            quantity: '',
                                                            lotNo: dailyFiller.lotNo,
                                                            expiry: dailyFiller.expiry
                                                        });
                                                    } else {
                                                        setFillerOptions({ ...fillerOptions, filler: value });
                                                    }
                                                }}
                                                getOptionLabel={option => option.name}
                                                getOptionValue={option => option?.id}
                                                getValue={id => fillerProducts.find(fillerItem => fillerItem.id === id)}
                                                label="Filler"
                                                required
                                                disabled={formRef.current.lockEdit}
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <CustomAutoComplete
                                                id="filler-quantity"
                                                // isSelect
                                                options={quantities}
                                                value={fillerOptions.quantity || null}
                                                onChange={(e, value) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setFillerOptions({ ...fillerOptions, quantity: value });
                                                }}
                                                getOptionLabel={option => option}
                                                label="Quantity"
                                                required
                                                disabled={formRef.current.lockEdit}
                                            />
                                        </Grid>
                                        {/*<Grid*/}
                                        {/*    container*/}
                                        {/*    item*/}
                                        {/*    xs={3}*/}
                                        {/*    direction="column"*/}
                                        {/*    justifyContent="center"*/}
                                        {/*    alignItems="center"*/}
                                        {/*>*/}
                                        {/*    <ColorPicker*/}
                                        {/*        color={fillerOptions.color}*/}
                                        {/*        changeColor={color => {*/}
                                        {/*            setIsCurrentlyEditingNote(true);*/}
                                        {/*            setFillerOptions({ ...fillerOptions, color: color.hex });*/}
                                        {/*        }}*/}
                                        {/*        disabled={formRef.current.lockEdit}*/}
                                        {/*    />*/}
                                        {/*</Grid>*/}
                                    </Grid>

                                    <Grid
                                        container
                                        item
                                        alignItems="center"
                                        className={classes.marginBottom}
                                        spacing={1}
                                    >
                                        <Grid item xs={5}>
                                            <TextField
                                                variant="outlined"
                                                label="Lot No"
                                                onChange={({ target }) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setFillerOptions({ ...fillerOptions, lotNo: target.value });
                                                }}
                                                value={fillerOptions.lotNo || ''}
                                                required
                                                className={classes.textField}
                                                style={{ width: '100%' }}
                                                disabled={formRef.current.lockEdit}
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <InputMask
                                                mask="99/99"
                                                value={fillerOptions.expiry || ''}
                                                onChange={({ target }) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setFillerOptions({ ...fillerOptions, expiry: target.value });
                                                }}
                                                disabled={formRef.current.lockEdit}
                                            >
                                                {inputProps => (
                                                    <TextField
                                                        {...inputProps}
                                                        variant="outlined"
                                                        label="Expiry"
                                                        required
                                                        className={classes.textField}
                                                        // ? NEEDS TO PASS IN THE INPUT MASK AND IN THE TEXTFIELD,
                                                        // ? OTHERWISE IT WILL NOT BE DISABLED
                                                        disabled={formRef.current.lockEdit}
                                                    />
                                                )}
                                            </InputMask>
                                        </Grid>
                                        <Grid
                                            container
                                            item
                                            xs={3}
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="center"
                                        >
                                            <Button
                                                disabled={isAddItemInActive}
                                                variant="contained"
                                                color="primary"
                                                onClick={addFiller}
                                                className={`${globalStyles.baseButton} ${classes.blueButton}`}
                                                style={{ margin: 0 }}
                                            >
                                                Add item
                                            </Button>
                                        </Grid>
                                    </Grid>

                                    {(form.fillers || []).map(fillerItem => (
                                        <Grid
                                            container
                                            item
                                            xs={12}
                                            key={fillerItem.id}
                                            className={classes.marginBottom}
                                            alignItems="center"
                                        >
                                            <Grid item xs={5}>
                                                <Typography className={classes.defaultFont}>
                                                    {fillerItem.filler.name} x{fillerItem.quantity}
                                                </Typography>
                                                <Typography className={classes.defaultFont}>
                                                    {fillerItem.lotNo}, {fillerItem.expiry}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={5} style={{ paddingLeft: 4 }}>
                                                <ColorPicker
                                                    color={fillerItem.color}
                                                    changeColor={color => {
                                                        setIsCurrentlyEditingNote(true);
                                                        const newFillerList = form.fillers.map(el => {
                                                            if (el.id === fillerItem.id) {
                                                                Object.assign(el, { color: color.hex });
                                                            }
                                                            return el;
                                                        });
                                                        setForm({ ...formRef.current, fillers: newFillerList });
                                                    }}
                                                    disabled={formRef.current.lockEdit}
                                                    icon={'PaletteIcon'}
                                                />
                                                <IconButton
                                                    disabled={formRef.current.lockEdit}
                                                    onClick={() => removeFiller(fillerItem.filler.id)}
                                                    style={{ marginLeft: 5 }}
                                                >
                                                    <DeleteOutlineOutlinedIcon className={classes.deleteIcon} />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    ))}

                                    <Grid item xs={6} className={classes.marginBottom}>
                                        <CustomAutoComplete
                                            id="filler-templates"
                                            isSelect
                                            options={fillerTemplatesOptions()}
                                            onChange={(e, template) => {
                                                setIsCurrentlyEditingNote(true);
                                                if (template) {
                                                    if (template.circles) {
                                                        template.circles.forEach(circleItem => {
                                                            if (
                                                                ['unit', 'color', 'left', 'top'].every(
                                                                    key => circleItem[key]
                                                                )
                                                            ) {
                                                                canvas.current.add(
                                                                    addCanvasCircle(
                                                                        {
                                                                            currentFiller: circleItem.product,
                                                                            type: 'filler',
                                                                            unit: circleItem.unit,
                                                                            area: circleItem.area
                                                                        },
                                                                        circleItem.color,
                                                                        circleItem.left,
                                                                        circleItem.top,
                                                                        circleItem.borderColor
                                                                    )
                                                                );
                                                            }
                                                        });
                                                    }
                                                    if (template.squares) {
                                                        template.squares.forEach(squareItem => {
                                                            if (
                                                                ['unit', 'color', 'left', 'top'].every(
                                                                    key => squareItem[key]
                                                                )
                                                            ) {
                                                                canvas.current.add(
                                                                    addCanvasSquare(
                                                                        {
                                                                            currentFiller: squareItem.product,
                                                                            type: 'filler',
                                                                            unit: squareItem.unit,
                                                                            area: squareItem.area
                                                                        },
                                                                        squareItem.color,
                                                                        squareItem.left,
                                                                        squareItem.top,
                                                                        squareItem.borderColor
                                                                    )
                                                                );
                                                            }
                                                        });
                                                    }
                                                    canvas.current.renderAll();
                                                    if (formRef.current.saveCanvasForCurrentPage) {
                                                        formRef.current.saveCanvasForCurrentPage();
                                                    } else {
                                                        updateForm();
                                                    }
                                                }
                                                if (template && template.canvasData) {
                                                    const currentCanvasData = canvas.current.toJSON();
                                                    const additionalCanvasData = JSON.parse(template.canvasData);
                                                    currentCanvasData.objects = currentCanvasData.objects.concat(
                                                        additionalCanvasData.objects
                                                    );
                                                    extendCanvasGroupProps();
                                                    canvas.current.loadFromJSON(currentCanvasData);
                                                    canvas.current.renderAll();
                                                    if (formRef.current.saveCanvasForCurrentPage) {
                                                        formRef.current.saveCanvasForCurrentPage();
                                                    } else {
                                                        updateForm();
                                                    }
                                                }
                                            }}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option}
                                            label="Templates"
                                            disabled={
                                                !fillerTemplatesOptions().length ||
                                                formRef.current.lockEdit ||
                                                (defaultUnitsDragErrors.length &&
                                                    !defaultUnitsDragErrors.every(
                                                        el =>
                                                            'Need to select an area' === el ||
                                                            'Filler is not selected' === el
                                                    ))
                                            }
                                        />
                                    </Grid>

                                    <Grid
                                        container
                                        item
                                        className={classes.marginBottom}
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <Grid item xs={5}>
                                            <CustomAutoComplete
                                                id="treatment-area"
                                                options={Object.values(FILLER_AREAS)}
                                                value={form.area || ''}
                                                onChange={(e, value) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setForm({ ...formRef.current, area: value });
                                                }}
                                                onClick={() => {
                                                    if (!isAddItemInActive) {
                                                        toastr.error('Please click the Add item button');
                                                    }
                                                }}
                                                getOptionLabel={option => option}
                                                label="Treatment area"
                                                required
                                                noCustomSearch
                                                disabled={
                                                    formRef.current.lockEdit ||
                                                    fillerFormLockValidation() ||
                                                    !isAddItemInActive
                                                }
                                            />
                                        </Grid>

                                        <Grid item xs={5}>
                                            <ProductPicker
                                                color={getCurrentFillerColor()}
                                                changeActiveFiller={(fillerId, quantity) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setForm({
                                                        ...formRef.current,
                                                        currentFiller: fillerId,
                                                        currentFillerQuantity: quantity,
                                                        borderColour: 'transparent'
                                                    });
                                                }}
                                                changeActiveShape={shape => {
                                                    setForm({ ...formRef.current, currentShape: shape });
                                                }}
                                                changeBorderColour={colour => {
                                                    setForm({ ...formRef.current, borderColour: colour });
                                                }}
                                                currentFiller={formRef?.current?.currentFiller}
                                                isAddItemInActive={isAddItemInActive}
                                                fillers={form.fillers || []}
                                                disabled={formRef.current.lockEdit || fillerFormLockValidation()}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Typography
                                            className={classes.defaultFont}
                                            style={
                                                formRef.current.lockEdit || !requiredFieldsCompleted
                                                    ? { color: 'gray' }
                                                    : {}
                                            }
                                        >
                                            Volume
                                        </Typography>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        direction="row"
                                        justify="space-between"
                                        alignItems="center"
                                        spacing={1}
                                        className={classes.marginBottom}
                                    >
                                        {fillerUnits.slice(0, 5).map(unit => (
                                            <UnitButton
                                                key={unit}
                                                unit={unit}
                                                unitErrors={defaultUnitsDragErrors}
                                                color={usedProduct.color}
                                                usedProduct={usedProduct}
                                                disabled={formRef.current.lockEdit || !requiredFieldsCompleted}
                                                shape={formRef.current.currentShape}
                                                borderColour={formRef.current.borderColour}
                                                isAddItemInActive={isAddItemInActive}
                                            />
                                        ))}
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        direction="row"
                                        justify="space-between"
                                        alignItems="center"
                                        spacing={1}
                                        className={classes.marginBottom}
                                    >
                                        <Grid item xs={4}>
                                            <Typography
                                                className={classes.defaultFont}
                                                style={
                                                    formRef.current.lockEdit || !requiredFieldsCompleted
                                                        ? { color: 'gray' }
                                                        : {}
                                                }
                                            >
                                                Custom Units (mls)
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <CustomAutoComplete
                                                id="custom-unit"
                                                freeSolo
                                                options={Array.from({ length: 15 }, (_, i) =>
                                                    (0.6 + i * 0.1).toFixed(1)
                                                )}
                                                value={form.unit?.toString() || ''}
                                                onChange={(_, value) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    const splitValue = value?.split('.') || [];
                                                    if (splitValue?.length > 2) return;
                                                    if (splitValue[1]?.length > 2) return;
                                                    setForm({ ...formRef.current, unit: value });
                                                }}
                                                required
                                                disabled={formRef.current.lockEdit || fillerFormLockValidation()}
                                            />
                                        </Grid>

                                        <UnitButton
                                            xs={3}
                                            color={getCurrentFillerColor()}
                                            unit={form.unit}
                                            unitErrors={customUnitsDragErrors}
                                            usedProduct={usedProduct}
                                            disabled={
                                                formRef.current.lockEdit ||
                                                !requiredFieldsCompleted ||
                                                fillerFormLockValidation()
                                            }
                                            shape={formRef.current.currentShape}
                                            borderColour={formRef.current.borderColour}
                                            isAddItemInActive={isAddItemInActive}
                                        />

                                        <Grid
                                            item
                                            xs={12}
                                            container
                                            direction="row"
                                            justify="flex-end"
                                            spacing={1}
                                            className={classes.marginBottom}
                                        >
                                            <Button
                                                disabled={!hasDroppedUnits()}
                                                onClick={() => {
                                                    setIsTemplateModalVisible(true);
                                                }}
                                                className={`${classes.saveTemplate} ${classes.font14}`}
                                            >
                                                Save new template
                                            </Button>
                                            {Boolean(templates?.toxin?.length) && (
                                                <IconButton
                                                    className={`${classes.deleteIcon}`}
                                                    onClick={() => {
                                                        setIsOpenDeleteTemplateModal(true);
                                                    }}
                                                >
                                                    <DeleteOutlineOutlinedIcon />
                                                </IconButton>
                                            )}
                                        </Grid>

                                        <Grid item container xs={12} spacing={1} className={classes.totalUnits}>
                                            <Areas />
                                            <Grid item xs={11}>
                                                <Typography
                                                    className={`${classes.rightAligned} ${classes.font14}`}
                                                    style={totalUnits === 0 ? { color: 'gray' } : {}}
                                                >
                                                    <strong>Total mls used</strong>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Typography className={`${classes.font14} ${classes.rightAligned}`}>
                                                    <strong>{totalUnits}</strong>
                                                </Typography>
                                            </Grid>
                                            {/*{totalUnused !== 0 && (*/}
                                            {/*    <>*/}
                                            {/*        <Grid item xs={11}>*/}
                                            {/*            <Typography*/}
                                            {/*                className={`${classes.rightAligned} ${classes.font14} ${classes.redText}`}*/}
                                            {/*            >*/}
                                            {/*                <strong>mls unused</strong>*/}
                                            {/*            </Typography>*/}
                                            {/*        </Grid>*/}
                                            {/*        <Grid item xs={1}>*/}
                                            {/*            <Typography*/}
                                            {/*                className={`${classes.font14} ${classes.redText} ${classes.rightAligned}`}*/}
                                            {/*            >*/}
                                            {/*                <strong>{totalUnused}</strong>*/}
                                            {/*            </Typography>*/}
                                            {/*        </Grid>*/}
                                            {/*    </>*/}
                                            {/*)}*/}
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                            {form.treatmentType === TREATMENT_TYPES.TOXIN && (
                                <>
                                    <Grid
                                        container
                                        item
                                        className={classes.marginBottom}
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <Grid item xs={6}>
                                            <CustomAutoComplete
                                                id="treatment-form-toxin"
                                                isSelect
                                                options={toxinProducts}
                                                value={form.toxin || ''}
                                                onChange={(e, value) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setForm({ ...formRef.current, toxin: value });
                                                }}
                                                getOptionLabel={option => option.name}
                                                getOptionValue={option => option?.id}
                                                getValue={id => toxinProducts.find(toxinItem => toxinItem.id === id)}
                                                label="Toxin"
                                                required
                                                disabled={formRef.current.lockEdit}
                                            />
                                        </Grid>
                                        <Grid item xs={5}>
                                            <CustomAutoComplete
                                                id="treatment-form-dilution"
                                                isSelect
                                                options={DILUTION_UNITS}
                                                value={form.dilution || ''}
                                                onChange={(e, value) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setForm({ ...formRef.current, dilution: value || undefined });
                                                }}
                                                getOptionLabel={option => option}
                                                getOptionValue={option => option}
                                                label="Dilution"
                                                required
                                                disabled={formRef.current.lockEdit}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        container
                                        item
                                        className={classes.marginBottom}
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <Grid item xs={6}>
                                            <TextField
                                                variant="outlined"
                                                label="Lot No"
                                                onChange={({ target }) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setForm({ ...formRef.current, lotNo: target.value || undefined });
                                                }}
                                                value={form.lotNo || ''}
                                                required
                                                className={classes.textField}
                                                disabled={formRef.current.lockEdit}
                                            />
                                        </Grid>

                                        <Grid item xs={5}>
                                            <InputMask
                                                mask="99/99"
                                                value={form.expiry || ''}
                                                onChange={({ target }) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setForm({ ...formRef.current, expiry: target.value || undefined });
                                                }}
                                                disabled={formRef.current.lockEdit}
                                            >
                                                {inputProps => (
                                                    <TextField
                                                        {...inputProps}
                                                        variant="outlined"
                                                        label="Expiry"
                                                        required
                                                        className={classes.textField}
                                                        // ? NEEDS TO PASS IN THE INPUT MASK AND IN THE TEXTFIELD,
                                                        // ? OTHERWISE IT WILL NOT BE DISABLED
                                                        disabled={formRef.current.lockEdit}
                                                    />
                                                )}
                                            </InputMask>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={6} className={classes.marginBottom}>
                                        <CustomAutoComplete
                                            id="toxin-templates"
                                            isSelect
                                            options={templatesToxin}
                                            onChange={(e, template) => {
                                                setIsCurrentlyEditingNote(true);
                                                if (template && template.circles) {
                                                    template.circles.forEach(circleItem => {
                                                        if (
                                                            ['unit', 'color', 'left', 'top'].every(
                                                                key => circleItem[key]
                                                            )
                                                        ) {
                                                            canvas.current.add(
                                                                addCanvasCircle(
                                                                    {
                                                                        toxin: form.toxin?.id,
                                                                        type: 'toxin',
                                                                        unit: circleItem.unit,
                                                                        area: circleItem.area
                                                                    },
                                                                    circleItem.color,
                                                                    circleItem.left,
                                                                    circleItem.top
                                                                )
                                                            );
                                                        }
                                                    });
                                                    canvas.current.renderAll();
                                                    if (formRef.current.saveCanvasForCurrentPage) {
                                                        formRef.current.saveCanvasForCurrentPage();
                                                    } else {
                                                        updateForm();
                                                    }
                                                }
                                                if (template && template.canvasData) {
                                                    const currentCanvasData = canvas.current.toJSON();
                                                    const additionalCanvasData = JSON.parse(template.canvasData);
                                                    currentCanvasData.objects = currentCanvasData.objects.concat(
                                                        additionalCanvasData.objects
                                                    );
                                                    extendCanvasGroupProps();
                                                    canvas.current.loadFromJSON(currentCanvasData);
                                                    canvas.current.renderAll();
                                                    if (formRef.current.saveCanvasForCurrentPage) {
                                                        formRef.current.saveCanvasForCurrentPage();
                                                    } else {
                                                        updateForm();
                                                    }
                                                }
                                            }}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option}
                                            label="Templates"
                                            disabled={
                                                formRef.current.lockEdit ||
                                                (defaultUnitsDragErrors.length &&
                                                    !defaultUnitsDragErrors.every(
                                                        el => 'Need to select an area' === el
                                                    ))
                                            }
                                        />
                                    </Grid>

                                    <Grid
                                        container
                                        item
                                        className={classes.marginBottom}
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <Grid item xs={8}>
                                            <CustomAutoComplete
                                                id="treatment-area"
                                                options={Object.values(BOTOX_TREATMENT_AREAS)}
                                                disabled={
                                                    formRef.current.lockEdit ||
                                                    (defaultUnitsDragErrors.length &&
                                                        !defaultUnitsDragErrors.every(
                                                            el => 'Need to select an area' === el
                                                        ))
                                                }
                                                value={form.area || ''}
                                                onChange={(e, value) => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setForm({ ...formRef.current, area: value });
                                                }}
                                                getOptionLabel={option => option}
                                                getOptionValue={option => option}
                                                label="Treatment area"
                                                required
                                                noCustomSearch
                                                isSelect
                                            />
                                        </Grid>

                                        <Grid item xs={3}>
                                            <ColorPicker
                                                color={form.treatmentColor}
                                                changeColor={color => {
                                                    setIsCurrentlyEditingNote(true);
                                                    setForm({ ...formRef.current, treatmentColor: color.hex });
                                                }}
                                                disabled={
                                                    formRef.current.lockEdit ||
                                                    (defaultUnitsDragErrors.length &&
                                                        !defaultUnitsDragErrors.every(
                                                            el => 'Need to select an area' === el
                                                        ))
                                                }
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Typography className={classes.defaultFont}>Units</Typography>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        direction="row"
                                        justify="space-between"
                                        alignItems="center"
                                        spacing={1}
                                        className={classes.unitSelector}
                                    >
                                        {customUnits.slice(0, 5).map(unit => (
                                            <UnitButton
                                                key={unit}
                                                unit={unit}
                                                unitErrors={defaultUnitsDragErrors}
                                                color={form.treatmentColor}
                                                usedProduct={usedProduct}
                                                disabled={formRef.current.lockEdit || !requiredFieldsCompleted}
                                            />
                                        ))}
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        direction="row"
                                        justify="space-between"
                                        alignItems="center"
                                        spacing={1}
                                        className={classes.marginBottom}
                                    >
                                        {customUnits.slice(5, 10).map(unit => (
                                            <UnitButton
                                                key={unit}
                                                unit={unit}
                                                unitErrors={defaultUnitsDragErrors}
                                                color={form.treatmentColor}
                                                usedProduct={usedProduct}
                                                disabled={formRef.current.lockEdit || !requiredFieldsCompleted}
                                            />
                                        ))}
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        container
                                        direction="row"
                                        justify="space-between"
                                        alignItems="center"
                                        spacing={1}
                                        className={classes.marginBottom}
                                    >
                                        <Grid item xs={4}>
                                            <Typography className={classes.defaultFont}>Custom Units</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <CustomAutoComplete
                                                id="custom-unit"
                                                freeSolo
                                                options={[...Array(101).keys()].map(String).slice(1)}
                                                value={form.unit?.toString() || ''}
                                                onChange={(_, value) => {
                                                    // setIsCurrentlyEditingNote(true);
                                                    const splitValue = value?.split('.') || [];
                                                    if (splitValue?.length > 2) return;
                                                    if (splitValue[1]?.length > 2) return;
                                                    setForm({ ...formRef.current, unit: value });
                                                }}
                                                required
                                                disabled={formRef.current.lockEdit}
                                            />
                                        </Grid>

                                        <UnitButton
                                            xs={3}
                                            unit={form.unit}
                                            unitErrors={customUnitsDragErrors}
                                            color={form.treatmentColor}
                                            usedProduct={usedProduct}
                                            disabled={formRef.current.lockEdit}
                                        />

                                        <Grid
                                            item
                                            xs={12}
                                            container
                                            direction="row"
                                            justify="flex-end"
                                            spacing={1}
                                            className={classes.marginBottom}
                                        >
                                            <Button
                                                disabled={!hasDroppedUnits()}
                                                onClick={() => {
                                                    setIsTemplateModalVisible(true);
                                                }}
                                                className={`${classes.saveTemplate} ${classes.font14}`}
                                            >
                                                Save new template
                                            </Button>
                                            {Boolean(templates?.toxin?.length) && (
                                                <IconButton
                                                    className={`${classes.deleteIcon}`}
                                                    onClick={() => {
                                                        setIsOpenDeleteTemplateModal(true);
                                                    }}
                                                >
                                                    <DeleteOutlineOutlinedIcon />
                                                </IconButton>
                                            )}
                                        </Grid>
                                        <Grid item container xs={12} spacing={1} className={classes.totalUnits}>
                                            <Areas />
                                            <Grid item xs={11}>
                                                <Typography className={`${classes.rightAligned} ${classes.font14}`}>
                                                    <strong>Total units used</strong>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Typography className={`${classes.font14} ${classes.rightAligned}`}>
                                                    <strong>{truncUnitCounter(totalUnits)}</strong>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                        </Box>
                    </Grid>
                )}
            </Grid>
            <DeleteTemplatesModal
                templates={(form.treatmentType === TREATMENT_TYPES.TOXIN ? templates.toxin : templates.filler) || []}
                isOpen={isOpenDeleteTemplateModal}
                setIsOpen={setIsOpenDeleteTemplateModal}
                deleteAction={
                    form.treatmentType === TREATMENT_TYPES.TOXIN
                        ? TreatmentNoteApi.deleteToxinsTemplate
                        : TreatmentNoteApi.deleteFillersTemplate
                }
                deleteForAllAction={
                    form.treatmentType === TREATMENT_TYPES.TOXIN
                        ? TreatmentNoteApi.deleteToxinsTemplateForAllPractitioners
                        : TreatmentNoteApi.deleteFillersTemplateForAllPractitioners
                }
                successMessage={`${
                    form.treatmentType === TREATMENT_TYPES.TOXIN ? 'Toxin' : 'Filler'
                } Template(s) successfully deleted`}
                refreshTemplates={loadTemplates}
                setTemplatesToxin={
                    form.treatmentType === TREATMENT_TYPES.TOXIN ? setTemplatesToxin : setTemplatesFiller
                }
                type="toxin"
            />
        </>
    );
};

TreatmentDesignForm.propTypes = {
    classes: PropTypes.object.isRequired,
    formRef: PropTypes.object.isRequired,
    fillerProducts: PropTypes.array.isRequired,
    templates: PropTypes.object.isRequired,
    loadTemplates: PropTypes.func.isRequired,
    canvas: PropTypes.object.isRequired,
    reload: PropTypes.func.isRequired,
    uploadedPhotos: PropTypes.array,
    setUploadedPhotos: PropTypes.func,
    setAllTreatments: PropTypes.object.isRequired,
    allTreatments: PropTypes.object.isRequired,
    toxinProducts: PropTypes.array.isRequired,
    getDailyData: PropTypes.func.isRequired,
    hasChangedNoteType: PropTypes.string,
    canvasSizeProps: PropTypes.object.isRequired,
    resetCanvasTools: PropTypes.func.isRequired,
    setShowUploadPhotosModal: PropTypes.func.isRequired,
    setShowTreatmentPhotosModal: PropTypes.func.isRequired,
    customer: PropTypes.func.isRequired,
    setUploadedDocs: PropTypes.func.isRequired,
    setIsFromDesignTab: PropTypes.func,
    setIsCurrentlyEditingNote: PropTypes.func.isRequired,
    setHasChangedNoteType: PropTypes.func.isRequired,
    ToUploadLhrTableRef: PropTypes.object,
    setComparisionLHRData: PropTypes.object,
    ToUploadBliplTableRef: PropTypes.object,
    setComparisionBLIPLData: PropTypes.object,
    isRequired: PropTypes.object.isRequired,
    latestToxins: PropTypes.array.isRequired,
    latestFillers: PropTypes.array.isRequired
};

export default withStyles(TreatmentFormStyles)(TreatmentDesignForm);
